// Gemeinsame Typen des Teilsystems „Mindmap & Tabelle“ (Bereich mindmap).
/** Farben für Knoten (Name → wird in der Oberfläche auf Töne abgebildet). */
export const MINDMAP_FARBEN = ['blau', 'gruen', 'gelb', 'orange', 'rot', 'lila', 'tuerkis', 'grau'];
/** Eigene Symbole für Knoten. */
export const MINDMAP_SYMBOLE = [
    'stern',
    'haken',
    'warnung',
    'frage',
    'idee',
    'flagge',
    'herz',
    'uhr',
    'geld',
    'person',
    'ort',
    'blitz',
];
/** Art einer frei angelegten Tabellenspalte. */
export const SPALTEN_TYPEN = ['text', 'zahl', 'betrag', 'datum', 'auswahl', 'person', 'haken', 'link', 'fortschritt'];
export const SPALTEN_TYP_NAMEN = {
    text: 'Text',
    zahl: 'Zahl',
    betrag: 'Betrag',
    datum: 'Datum',
    auswahl: 'Auswahl (z. B. Status)',
    person: 'Person (Projektmitglied)',
    haken: 'Haken (ja/nein)',
    link: 'Link (nur Text, wird nie geöffnet)',
    fortschritt: 'Fortschritt in % (0–100)',
};
/** Bezug, unter dem ein hochgeladenes Bild bis zum Übernehmen liegt (Upload über die Datei-Ablage des Kerns). */
export const BILD_EINLESEN_BEZUG = 'bild-einlesen';
/** Unterkanal für die Liste der Karten eines Projekts: p:<projekt>:mindmap:karten → { typ: 'karten' }. */
export const MINDMAP_LISTEN_KANAL = 'karten';
//# sourceMappingURL=mindmap.js.map